// extracted by mini-css-extract-plugin
module.exports = {"InspirationShopTheRoom":"ShopTheRoomDetails_InspirationShopTheRoom__mcqiD"};